import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BASE_URL } from '@simOn/utils/tokens';

export const homeyApiInterceptor: HttpInterceptorFn = (req, next) => {
  const baseUrl = inject(BASE_URL);
  if (req.url.includes('/Homey') && baseUrl.includes('localhost')) {
    req = req.clone({
      setHeaders: {
        'X-Homey-Local': 'true'
      }
    });
  }
  return next(req);
};
